export default "__VITE_ASSET__$l8TMXH1__"